import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import userService from "../services/userService";

export default function AddressBook() {
  const { user, setUser } = useContext(AuthContext);

  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState("");
  const [editContact, setEditContact] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (user?.addressBook) {
      setContacts(user.addressBook);
    }
  }, [user]);

  const syncAddressBook = async () => {
    const updated = await userService.getAddressBook();
    setContacts(updated);
    setUser((prev) => (prev ? { ...prev, addressBook: updated } : prev));
  };

  const filtered = contacts.filter((c) =>
    (
      c.code +
      " " + c.name +
      " " + c.company +
      " " + c.email +
      " " + c.phone +
      " " + c.vat +
      " " + c.cf +
      " " + c.pec
    ).toLowerCase().includes(search.toLowerCase())
  );

  const handleSave = async (e) => {
    e.preventDefault();

    const data = {
      code: e.target.code.value,
      name: e.target.name.value,
      company: e.target.company.value,
      email: e.target.email.value,
      pec: e.target.pec.value,
      phone: e.target.phone.value,
      vat: e.target.vat.value,
      cf: e.target.cf.value,
      address: e.target.address.value,
      codepag: e.target.codepag.value,
      codpagd: e.target.codpagd.value,
    };

    if (editContact) {
      await userService.updateAddressBookContact(editContact.id, data);
    } else {
      await userService.addAddressBookContact(data);
    }

    await syncAddressBook();
    setShowForm(false);
    setEditContact(null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Eliminare il contatto?")) return;
    await userService.deleteAddressBookContact(id);
    await syncAddressBook();
  };

  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    await userService.importAddressBook(file);
    await syncAddressBook();
  };

  return (
    <div className="ab-container">
      <div className="ab-header">
        <input
          type="text"
          className="ab-search"
          placeholder="Cerca per nome, azienda, email, CF, P.IVA..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <label className="ab-btn ab-import">
          Importa Excel
          <input type="file" accept=".xlsx,.csv" hidden onChange={handleImport} />
        </label>

        <button className="ab-btn ab-new" onClick={() => { setEditContact(null); setShowForm(true); }}>
          ➕ Nuovo
        </button>
      </div>

      <div className="ab-list-header">
        <div className="ab-col code">Codice</div>
        <div className="ab-col main">Contatto</div>
        <div className="ab-col email">Email</div>
        <div className="ab-col phone">Telefono</div>
        <div className="ab-col vat">P.IVA / CF</div>
        <div className="ab-col actions">Azioni</div>
      </div>

      <div className="ab-list">
        {filtered.map((c) => (
          <div key={c.id} className="ab-row" onClick={() => { setEditContact(c); setShowForm(true); }}>
            <div className="ab-col code">{c.code || "—"}</div>

            <div className="ab-col main">
              <strong>{c.name}</strong>
              <div>{c.company}</div>
            </div>

            <div className="ab-col email">{c.email || "—"}</div>

            <div className="ab-col phone">{c.phone || "—"}</div>

            <div className="ab-col vat">
              {c.vat || "—"}
              <div>{c.cf}</div>
            </div>

            <div className="ab-col actions">
              <button onClick={(e) => { e.stopPropagation(); setEditContact(c); setShowForm(true); }}>✏️</button>
              <button onClick={(e) => { e.stopPropagation(); handleDelete(c.id); }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>

      {showForm && (
        <div className="ab-modal-overlay" onClick={() => setShowForm(false)}>
          <div className="ab-modal" onClick={(e) => e.stopPropagation()}>
            <h2>{editContact ? "Modifica Contatto" : "Nuovo Contatto"}</h2>

            <form className="ab-form" onSubmit={handleSave}>
              <div className="ab-col2">
                <label>Codice Cliente <input name="code" defaultValue={editContact?.code} /></label>
                <label>Nome <input name="name" required defaultValue={editContact?.name} /></label>
                <label>Azienda <input name="company" defaultValue={editContact?.company} /></label>
                <label>Email <input name="email" defaultValue={editContact?.email} /></label>
                <label>PEC <input name="pec" defaultValue={editContact?.pec} /></label>
                <label>Telefono <input name="phone" defaultValue={editContact?.phone} /></label>
              </div>

              <div className="ab-col2">
                <label>P.IVA <input name="vat" defaultValue={editContact?.vat} /></label>
                <label>Codice Fiscale <input name="cf" defaultValue={editContact?.cf} /></label>
                <label>Indirizzo <input name="address" defaultValue={editContact?.address} /></label>
                <label>Codice Pagamento <input name="codepag" defaultValue={editContact?.codepag} /></label>
                <label>Descr. Pagamento <input name="codpagd" defaultValue={editContact?.codpagd} /></label>
              </div>

              <div className="ab-actions">
                <button type="submit" className="save">Salva</button>
                <button type="button" className="cancel" onClick={() => setShowForm(false)}>Annulla</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
